import React from 'react';
import PropTypes from 'prop-types';

import { SharedZoneBlocks } from 'store/SharedZone/blocks/selectors';

import BannersBlock from '../BannersBlock';
import BeautyContentBlock from '../BeautyContentBlock';
import CustomBlock from '../CustomBlock';
import FullScreenBannerBlock from '../FullScreenBannerBlock';
import InfoGraphic from '../InfoGraphic';
import PromoBlock from '../PromoBlock';
import SliderBlock from '../SliderBlock';
import TagsBlock from '../TagsBlock';
import Videos from '../Videos';
import {
  BLOCK_TYPE_BANNERS,
  BLOCK_TYPE_BEAUTY_CONTENT,
  BLOCK_TYPE_CUSTOM,
  BLOCK_TYPE_FULLSCREEN_BANNER,
  BLOCK_TYPE_GOODS_DAY,
  BLOCK_TYPE_INFOGRAPHIC,
  BLOCK_TYPE_PROMO,
  BLOCK_TYPE_SLIDER,
  BLOCK_TYPE_TAGS,
  BLOCK_TYPE_VIDEOS,
} from './constants';

/** TODO: Maybe someday move PageHeading from every block - here, if it has same design */
const SwitchBlock = ({ type }) => {
  switch (type) {
    case BLOCK_TYPE_VIDEOS:
      return <Videos />;
    case BLOCK_TYPE_PROMO:
      return <PromoBlock />;
    case BLOCK_TYPE_SLIDER:
      return <SliderBlock />;
    case BLOCK_TYPE_BANNERS:
      return <BannersBlock />;
    case BLOCK_TYPE_FULLSCREEN_BANNER:
      return <FullScreenBannerBlock />;
    case BLOCK_TYPE_INFOGRAPHIC:
      return <InfoGraphic />;
    case BLOCK_TYPE_CUSTOM:
      return <CustomBlock />;
    case BLOCK_TYPE_BEAUTY_CONTENT:
      return <BeautyContentBlock />;
    case BLOCK_TYPE_TAGS:
      return <TagsBlock />;
    case BLOCK_TYPE_GOODS_DAY:
      return null;
    default:
      return (
        <pre>
          Missing type:
          {JSON.stringify(type, null, 2)}
        </pre>
      );
  }
};

SwitchBlock.propTypes = {
  type: PropTypes.string,
};

const mapStateToProps = (state) => ({
  type: SharedZoneBlocks.getType(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(SwitchBlock);
